<template>
  <div>
    <div 
      class="modal in"
      style="display: block;"
      tabindex="-1" 
      role="dialog"
    >
      <div 
        class="modal-dialog modal-lg" 
        role="document"
      >
        <div class="modal-content">
          <div class="modal-header">
            <a 
              class="close" 
              @click="cancel"
            >
              <i 
                class="typcn typcn-delete" 
                aria-hidden="true"
              />
            </a>
            <h4 
              v-if="!currentRoute.id" 
              class="modal-title"
            >
              {{ $t('TARGET_ROUTE_HEADER') }}
            </h4>
            <h4 
              v-if="currentRoute.id" 
              class="modal-title"
            >
              {{ $t('TARGET_ROUTE_EDIT_HEADER') }}
            </h4>
          </div>
          <div class="modal-body">
            <ValidationObserver 
              ref="form" 
              v-slot="{ handleSubmit }" 
              slim
            >
              <div class="container-fluid">
                <form
                  name="vm.campaignBasicDetailsForm"
                  class="form-horizontal"
                  @submit.prevent="handleSubmit(onSubmit)"
                >
                  <div 
                    class="form-group"
                  >
                    <label 
                      class="col-sm-3 col-md-3 control-label"
                    >
                      {{ $t('TARGET_ROUTE_NAME') }}
                      <a>
                        &nbsp;&nbsp;<i 
                          v-tooltip.right.hover="$t('TARGET_ROUTE_NAME_TT')"
                          class="fa fa-question-circle"                           
                        />
                      </a>
                    </label>
                    <div 
                      class="col-sm-9 form-control-static"
                    >
                      {{ selectedTarget.name }}
                    </div>
                  </div>
                  
                  <CallRouteForm
                    :current-call-route="currentRoute"
                    :selected-target="selectedTarget"
                    :hide-conversion="false"
                    :hide-duplicate="false" 
                    :is-rpc="isRpc"
                    :route-container-type="routeContainerType"
                    :route-container="routeContainer"
                    :on-submit-success="handleSuccess"       
                  />
                </form>
              </div>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
    <div 
      class="modal-backdrop in"
    />
  </div>
</template>

<script>
import messages from '../locales';
import sharedMessages from '@/core/locales';
import CallRouteForm from './CallRouteForm.vue';

export default {
  name: 'RoutingNewTargetRoute',
  components: { CallRouteForm },
  props: {
    selectedTarget: { type: Object, default: () => ({}) },
    currentRoute: { type: Object, default: () => ({}) },
    isRpc: { type: Boolean, default: false },
    showLoader: { type: Boolean, default: false },
    routeContainerType: { 
      type: String, 
      default: 'campaign',
      validator: (value) => ['campaign', 'callPlan'].includes(value)
    },
    routeContainer: { type: Object, default: () => ({}) }
  },
  data() {
    return {
      campaignName: '',
      priority: '',
      weight: '',
    };
  },
  methods: {
    onSubmit() {
      const updatedRoute = {
        ...this.currentRoute,
        name: this.campaignName,
        priority: this.priority,
        weight: this.weight,
        targetid: this.selectedTarget.id
      };
      
      this.$emit('create-update', updatedRoute);
    },
    cancel() {
      this.$emit('cancel');
    },
    updateCallRoute(updatedRoute) {
      this.$emit('update:currentRoute', updatedRoute);
    },
    handleSuccess(data) {
      this.$emit('create-update', data);
      this.cancel();
    }
  },
  
  i18n: {
    messages,
    sharedMessages,
    locale: 'en'
  },
  
};
</script>